<template lang="pug">
  .main-Layouts(v-if="company && member")
    y-dialog(v-model="newUpdate" persistent width="340" content-class="round-2xl")
      v-card.py-2.px-1
        v-card-title.text-lg.font-semibold(style="height:56px; justify-content: center;") {{ $t('latest_version_available') }}
        v-card-text.primary--text.pb-0
          .text-sm.mb-4.neutral500--text.text-center {{ $t('latest_version_available_desc') }}
        v-card-actions
          v-spacer
          y-button.ml-2(label="Close" color="white" @click='newUpdate = false' size="sm")
          //- y-button.ml-2(:label="$t('later')" color="white" text @click='newUpdate = false' size="sm")
          //- y-button(:label="$t('refresh_now')" @click="reload" size="sm" color="info")
    .admin-views
      app-top-bar
      v-container(v-if="isReloading")
        v-layout.my-6
          v-row.fill-height.ma-0(align='center' justify='center')
            div.text-center
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
              .s1.mt-4 {{ $t('refreshing') }}...
      template(v-else)
        mobile-top-bar
        router-view(:company.sync="company")
      .subscribe
        EmptySubscriptionModal(v-if="showSubscribeModal && !allowedPathAfterInactive" :open.sync="showSubscribeModal" :company="company")

    // Mobile Bottom Navigation
    mobile-bottom-navigation
    // userback
    user-back-setup
</template>

<script>
import Vue from 'vue'
import {mapState, mapGetters, mapActions} from 'vuex'
import * as Sentry from '@sentry/vue'
import AppTopBar from '@/components/hq/AppTopBar.vue'
import MobileBottomNavigation from '@/components/hq/MobileBottomNavigation.vue'
import RegisterCard from '@/views/admin/billing/RegisterCard.vue'
import EmptySubscriptionModal from '@/components/billing/EmptySubscriptionModal.vue'
import Cookies from 'js-cookie'
import UserBackSetup from '@/components/UserBackSetup.vue'
import MobileTopBar from "@/components/hq/MobileTopBar.vue"

Vue.mixin({
  methods: {
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    Auth(type, id) {
      const permission = this.$store.state.permission
      if (type === 'root') {
        if (permission.root[id] != undefined) {
          return permission.root[id]
        }
      } else if (type === 'menu') {
        if (permission.side_menu[id] != undefined) {
          return permission.side_menu[id]
        }
      } else if (type === 'page') {
        if (permission.page_permissions[id]) {
          return permission.page_permissions[id].enter
        }
      } else if (type === 'component') {
        const path = id.split('#')[0]
        const component = id.split('#')[1]
        if (permission.page_permissions[path] && permission.page_permissions[path].components[component] != undefined) {
          return permission.page_permissions[path].components[component]
        }
      }
      return true
    }
  }
})

export default {
  name: 'AdminHqDashboard',
  components: {
    AppTopBar, MobileBottomNavigation, RegisterCard, EmptySubscriptionModal, UserBackSetup, MobileTopBar
  },
  data: () => ({
    isReloading: false,
    newUpdate: false,
    showSubscribeModal: false,
    showSendReminderDialog: false,
    showScheduleReminderDialog: false,
    isAtTop: false,
    offer1010Active: false,
    pStart: {x: 0, y: 0},
    pStop: {x: 0, y: 0},
    subscriptionPaymentCallback: null
  }),
  computed: {
    ...mapState('user', ['user', 'member', 'deviceId', 'walkThrough']),
    ...mapGetters({
      company: 'getCompany',
      currency: 'getCompanyCurrency'
    }),
    allowedPathAfterInactive() {
      const slashes = this.$route.path.toString().split('/')
      if (slashes.length > 3 && slashes[3].toString().includes('bills')) {
        return true
      } else if (slashes.length > 3 && slashes[3].toString().includes('subscription')) {
        return true
      } else if (slashes.length > 2 && slashes[2].toString().includes('notifications')) {
        return true
      }
      return false
    },
  },
  watch: {
    '$route.path'(val) {
      window.pageYOffset = 0
      document.documentElement.scrollTop = 0
      if (!this.Auth('page', val)) {
        this.$router.push('/admin/hq/insights/today')
      }
      // if (this.$route.path === '/admin/hq/billing/subscription') {
      //   this.showSubscribeModal = false
      //   return
      // }
      // this.showSubscribeModal = this.Auth('root', 'account_suspended')  || !this.Auth('root', 'subscribe_multibranch')
    },
    '$store.state.ui.pendingOrderCount'(val) {
      this.menuOptions.pending_order_count = val
    },
    '$store.state.subscriptions.version'() {
      this.updateSubscriptions()
    },
    '$vuetify.breakpoint.mobile'(isMobile) {
      if (isMobile) {
        this.$store.commit('ui/setDisplaySize', 'medium')
      }
    }
  },
  mounted() {
    const cookieUser = Cookies.get('user')
    if (!cookieUser) {
      this.$store.commit('ui/setRedirectPath', this.$route.path)
      this.goToSignOut()
    }

    if (!this.user) {
      let user = JSON.parse(cookieUser)
      this.$store.commit('user/setUser', user)
    }

    Sentry.setUser({'id': this.user.id, 'email': this.user.email})

    // Set display size to medium on mobile devices (initial check)
    if (this.$vuetify.breakpoint.mobile) {
      this.$store.commit('ui/setDisplaySize', 'medium')
    }

    this.fetchCompany()
    this.fetchNewFeatures()
    if (this.$isMobile) {
      window.addEventListener('touchstart', (e) => {
        this.swipeStart(e)
      }, false)
      window.addEventListener('touchend', (e) => {
        this.swipeEnd(e)
      }, false)
    }

    this.resetCurrency()
  },
  beforeDestroy() {
    this.$store.commit('hq/setIsHq', false)

    // Remove event listeners if they exist
    if (this.$isMobile) {
      window.removeEventListener('touchstart', this.swipeStart, false)
      window.removeEventListener('touchend', this.swipeEnd, false)
    }
  },
  methods: {
    ...mapActions([
      'updateCompany', 'showMessage'
    ]),
    onIntersect(entries) {
      this.isAtTop = entries[0].isIntersecting
    },
    swipeStart(e) {
      if (typeof e['targetTouches'] !== "undefined") {
        var touch = e.targetTouches[0];
        this.pStart.x = touch.screenX;
        this.pStart.y = touch.screenY;
      } else {
        this.pStart.x = e.screenX;
        this.pStart.y = e.screenY;
      }
    },
    swipeEnd(e) {
      if (typeof e['changedTouches'] !== "undefined") {
        var touch = e.changedTouches[0];
        this.pStop.x = touch.screenX;
        this.pStop.y = touch.screenY;
      } else {
        this.pStop.x = e.screenX;
        this.pStop.y = e.screenY;
      }
      this.swipeCheck()
    },
    onRefresh() {
      if (this.isAtTop && !this.$store.state.ui.modalDialog.visible) {
        this.fetchSettingsMenu()
        this.isReloading = true
        setTimeout(() => {
          this.isReloading = false
        }, 500)
      }
    },
    swipeCheck() {
      var changeY = this.pStart.y - this.pStop.y;
      var changeX = this.pStart.x - this.pStop.x;
      if (this.isPullDown(changeY, changeX)) {
        this.onRefresh()
      }
    },
    isPullDown(dY, dX) {
      // methods of checking slope, length, direction of line created by swipe action
      let minChangeRatio = 1.5
      if (this.$store.state.mobileapp.device && this.$store.state.mobileapp.device.platform === 'ios') {
        minChangeRatio = 2
      }
      return dY < 0 && (
          (Math.abs(dX) <= 100 && Math.abs(dY) >= 300 / minChangeRatio)
          || (Math.abs(dX) / Math.abs(dY) <= 0.3 && dY >= 60 / minChangeRatio)
      )
    },
    fetchCompany() {
      let url = `/companies/${this.$subdomain}/`
      let params = {use_slug: 'true'}
      if (!this.$subdomain) {
        url = `/companies/${this.company.id}/`
        params = {}
      }
      this.$axios.get(url, {params})
          .then(resp => {
            const latestCompany = resp.data
            this.updateCompany(latestCompany)
            this.fetchMember()
            this.checkCreditReloadPayment()
            this.$store.commit('mobileapp/setCompanySlug', latestCompany.slug)
            this.resetCurrency()
          })
          .catch(() => {
            this.goToCompanyList()
          })
    },
    fetchMember() {
      this.$axios.get('/members/', {params: {user: this.user.id, company: this.company.id}})
          .then(resp => {
            if (resp.data.results.length === 0) {
              this.goToCompanyList()
            } else {
              this.$store.commit('user/setMember', resp.data.results[0])

              // Analytics
              if (this.deviceId) {
                this.$logEvent('company_session.started')
              }
            }
          })
          .catch(() => {
          })
          .finally(() => {
            this.fetchSettingsMenu()
          })
    },
    goToSignOut() {
      if (this.$subdomain) {
        document.location.href = `https://${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/signout`
      } else {
        this.$router.push('/signout')
      }
    },
    goToCompanyList() {
      this.$store.commit('ui/setRedirectPath', location.pathname + location.search)
      if (this.$subdomain) {
        document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/companies`
      } else {
        this.$router.push('/companies')
      }
    },
    reload() {
      location.reload()
    },
    updateSubscriptions() {
      this.$store.commit('subscriptions/startFetching')

      // Get member permissions
      this.$axios.get(`/members/${this.member.id}/permissions`)
          .then((response) => {
            const permissions = response.data
            this.$store.commit('permission/setPermissions', permissions)
            if (!this.Auth('page', this.$route.path)) {
              this.$router.push('/admin/hq/insights/today').catch(() => null)
            }
            // if (this.$route.path === '/admin/hq/billing/subscription') {
            //   this.showSubscribeModal = false
            //   return
            // }
            // this.showSubscribeModal = this.Auth('root', 'account_suspended') || !this.Auth('root', 'subscribe_multibranch')
          }, () => {
          })

      // Get company subscriptions
      this.$axios.get(`/subscription/subscriptions/?company=${this.company.id}&terminated=false&ordering=start_date&expand=contract&page_size=1000`)
          .then((response) => {
            this.$store.commit('subscriptions/setSubscriptions', response.data.results)
            this.$store.commit('subscriptions/setDefaultFeature', this.company)
          }, () => {
          })

      // Get company genese
      this.$axios.get(`/companies/${this.company.id}/genes`)
          .then((response) => {
            this.$store.commit('subscriptions/setLimitations', response.data)
            this.$store.commit('subscriptions/setGenes', response.data)
          }, () => {
          })

    },
    fetchSettingsMenu() {
      if (!this.company) return

      this.updateSubscriptions()

      this.$axios.get(`/companies/${this.company.id}/allowed_payment_gateways/`).then((response) => {
        this.menuOptions.yezzapay_enable = response.data.yezzapay
      })
          .catch(() => {
          })

      // Notifications count
      const params = {
        page: 1,
        page_size: 1,
        form__company: this.company.id,
        status: 'processed',
        form_type_exclude: 'book_income'
      }
      if (this.member.role !== 'Admin') {
        params['member'] = this.member.id
      }
      this.$axios.get('/leads/', {params: params}).then((response) => {
        this.menuOptions.pending_order_count = response.data.count
        this.$store.commit('ui/setPendingOrderCount', response.data.count)
      }).catch(() => {
      })

      this.$axios.get(`/notifications/?member=${this.member.id}&read=false&&page_size=0`).then((response) => {
        this.menuOptions.unread_count = response.data.count
      }).catch(() => {
      })

    },
    fetchNewFeatures() {
      this.$axios.get('/news', {page_size: 1})
          .then((response) => {
            // Get localstorage data
            const newFeatureLastRead = localStorage.getItem('new_feature_last_read')
            // When response is empty
            if (response.data.count === 0) {
              this.$store.commit('ui/setHasNewFeature', false)
            } else {
              // first time user without localstorage
              if (!newFeatureLastRead) {
                this.$store.commit('ui/setHasNewFeature', true)
              } else {
                // For user than already created localstorage
                const newFeatureLatestId = response.data.results[0].id
                const hasNewFeature = newFeatureLatestId > newFeatureLastRead
                this.$store.commit('ui/setHasNewFeature', hasNewFeature)
              }
            }
          })
          .catch(() => {
          })
    },
    checkCreditReloadPayment() {
      if (this.$route.query.status == 'prepaid_topup_payment_success' || this.$route.query.status == 'prepaid_topup_payment_failed') {
        const reminder = this.$store.state.reminder.data
        if (reminder && reminder.type === 'default') {
          this.showSendReminderDialog = true
        } else if (reminder && reminder.type === 'schedule') {
          this.showScheduleReminderDialog = true
        }
      }
    },
    resetCurrency() {
      if (this.currency.symbol != this.$currency.symbol) {
        Vue.prototype.$currency = this.currency
        this.reload()
      }
    }
  },
  wamp: {
    subscribe: {
      'new-update'() {
        this.newUpdate = true
      }
    }
  }
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "latest_version_available": "Latest version is available",
    "latest_version_available_desc": "For your convenience, please refresh the page to prevent errors from happening",
    "later": "Later",
    "refresh_now": "Refresh Now",
    "refreshing": "Refreshing"
  },
  "id": {
    "latest_version_available": "Versi terbaru tersedia",
    "latest_version_available_desc": "Untuk kenyamanan kamu, harap segarkan halaman untuk mencegah kesalahan terjadi",
    "later": "Nanti",
    "refresh_now": "Segarkan sekarang",
    "refreshing": "Sedang disegarkan"
  }
}
</i18n>
